<div class="image-snippet-dialog">
  <button mat-icon-button class="close-btn" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="image-snippet-row">
    <div class="image-snippet-col">
      <p>Captured</p>
      <img [src]="data.captured" />
    </div>
    <div class="image-snippet-col">
      <p>Search Region</p>
      <img [src]="data.search" />
    </div>
    <!-- <div class="image-snippet-col">
      <p>Verified</p>
      <img [src]="data.verified" />
    </div> -->
  </div>
</div>